const home = function home() {
  const conteudo = $('.conteudo');
  conteudo.load('home.html', function () {

    //carousel de clientes
    (function () {
      $('[data-html="clientes-carousel"]').load('components/clientes-carousel.html', function () {
        //Carousel de clientes do site
        $(".clientes-digi").owlCarousel({
          loop: true,
          center: true,
          autoWidth: true,
          margin: 30,
          autoplay: true,
          stagePadding: 15,
          autoplayTimeout: 2000,
          autoplayHoverPause: true,
          responsive: {
            0: {
              items: 1
            },
            480: {
              items: 4
            },
            768: {
              items: 5
            }
          }
        });
      });
    })();

    animaChamada();
    animaCases();
    animaHeader();

    $('.conteudo').addClass('home');

    const cases = $('[data-case]');
    cases.each((i, item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        const dataLink = $(this).attr('href');

        $('.conteudo').load(dataLink, function () {
          const pageAtual = $('[data-page]');
          const classePage = dataLink.split('.')[0];

          if ($('.conteudo').attr('class').split(' ')[1] === 'home') {
            $('.conteudo').removeClass('home');
          }

          $(this).addClass(classePage);
          pageAtual.attr('data-page', classePage);

          function removeClasse() {
            setTimeout(function () {
              $('.conteudo').removeClass(classePage);
            }, 500);
          }

          loaddingComponents();
          $('html, body').scrollTop(0);
          controleVolumeVideo();

          if ($('html')[0].lang === "en") {
            switch ($('.conteudo').attr('class').split(' ')[1]) {
              case 'case-dell-vale':
                trocaIdioma();
                removeClasse();
                animaCases = null;
                break;
              case 'case-mitsubishi':
                trocaIdioma();
                removeClasse();
                break;
              case 'case-pompom':
                trocaIdioma();
                removeClasse();
                break;
              case 'case-royal-canin':
                trocaIdioma();
                removeClasse();
                break;
              case 'case-skyn':
                trocaIdioma();
                removeClasse();
                break;
              case 'case-samsung':
                trocaIdioma();
                removeClasse();
                break;
            }
          }

          if ($('html')[0].lang === "pt") {
            switch ($('.conteudo').attr('class').split(' ')[1]) {
              case 'case-dell-vale':
                removeClasse();
                break;
              case 'case-mitsubishi':
                removeClasse();
                break;
              case 'case-pompom':
                removeClasse();
                break;
              case 'case-royal-canin':
                removeClasse();
                break;
              case 'case-skyn':
                removeClasse();
                break;
              case 'case-samsung':
                trocaIdioma();
                removeClasse();
                break;
            }
          }
        });
      });
    });

    // Formulario
    $('.formasp').on('submit', function () {
      var emailContato = "contato@digi.ag"; // Escreva aqui o seu e-mail

      var that = $(this),
        url = that.attr('action'),
        type = that.attr('method'),
        data = {};

      that.find('[name]').each(function (index, value) {
        var that = $(this),
          name = that.attr('name'),
          value = that.val();

        data[name] = value;
      });

      $.ajax({
        url: url,
        type: type,
        data: data,
        success: function (response) {

          if ($('[name="leaveblank"]').val().length != 0) {
            $('.formphp').html("<div id='form-erro'></div>");
            $('#form-erro').html("<span>Falha no envio!</span><p>Você pode tentar novamente,<br> ou enviar direto para o e-mail " + emailContato + " </p>")
              .hide()
              .fadeIn(1500, function () {
                $('#form-erro');
              });
          } else {

            const htmlLang = document.querySelector('html').lang;
            let fMsg;
            console.log(htmlLang);
            
            if(htmlLang === 'pt') {
              fMsg = "<span>Agradecemos o seu contato e retornaremos o mais breve possível. </span><p>Para contato imediato, por favor, nos acione via Whatsapp pelo número: <br> <a href='tel:+551198144-5700'>+55 11 98144-5700</a></p>";
            } else if (htmlLang === 'en') {
              fMsg = "<span>Thank you for contacting us. We will get back to you as soon as possible.</span><p>If you need an immediate response, please contact us via WhatsApp: <br> <a href='tel:+551198144-5700'>+55 11 98144-5700</a></p>";
            }

            $('.formasp').html("<div id='form-send'></div>");
            $('#form-send').html(fMsg)
              .hide()
              .fadeIn(1500, function () {
                $('#form-send');
              });
          };
        },
        error: function (response) {
          $('.formasp').html("<div id='form-erro'></div>");
          $('#form-erro').html("<span>Falha no envio!</span><p>Você pode tentar novamente,<br> ou enviar direto para o e-mail " + emailContato + " ou pelo número de Whatsapp: <br> <a href='tel:+551198144-5700'>+55 11 98144-5700</a></p>")
            .hide()
            .fadeIn(1500, function () {
              $('#form-erro');
            });
        }
      });

      return false;
    });

    $('[data-form="click"]').click(function () {
    	$('[data-form="contato"]').addClass('active');
    });

  });
}